import styled from "styled-components";
import { Container, Section as NewSection, CTA } from "components/shared";
import respondTo from "util/respondTo";

export const Section = styled(NewSection)`
    background: var(--dark-2);
`;

export const WorksContainer = styled(Container)`
    margin-top: 2rem;
    display: grid;
    gap: 2.5rem;
`;

// WORK CARD

export const Card = styled.figure`
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    ${respondTo.sm`
        grid-template-columns: 1fr;
        font-size:1.2rem;
    `}
`;

export const CardDemo = styled.a`
    display: block;
    overflow: auto;
    height: 13.4rem;
    position: relative;
    ::-webkit-scrollbar {
        position: absolute;
        background: transparent;
    }
    
    ${respondTo.sm`
        height:16rem;
        overflow:hidden;
    `}

    img {
        display: block;
        width: 100%;
        height: auto;
    }
`;

export const CardInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    background: var(--main-3);

    ${respondTo.sm`
        padding: 3rem;

        & > *:not(:last-child){
            margin-bottom:1rem;
        }
    `}

    h3 {
        font-family: "Montserrat", sans-serif;
    }

`;

export const TechList = styled.ul`
    display: flex;
    align-items: center;

    h3 {
        margin-right: 0.5rem;
    }
`;

export const TechIcon = styled.li`
    margin-right: calc(10px + 0.3rem);
    svg {
        width: 1.5rem;
        height: 1.5rem;
    }
`;

export const Link = styled.a`
    display: inline-block;

    &:hover svg {
        fill: var(--main);
    }

    svg {
        fill: white;
        width: 2rem;
        height: 2rem;
    }
`;

export const Links = styled.div`
    display: flex;
    align-items: center;
`;

export const Live = styled(CTA)`
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    padding: 0.5rem;
    flex: 1;
    justify-content: center;
    margin: 0;
    svg {
        fill: white;
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 0.3rem;
    }

    &:first-child {
        margin-right: 1rem;
    }
`;
